<template>
    <div>Manning</div>
</template>

<script>
    export default {
        name: "Manning"
    }
</script>

<style scoped>

</style>
